export const socialSignIn = (source: string) => {
  switch (source) {
    case 'Google':
      window.open(
        `${process.env.REACT_APP_API_ENDPOINT_SOCKET}/social/google/oauth?mode=login`,
        '_self'
      );
      break;
    case 'Outlook':
      window.open(
        `${process.env.REACT_APP_API_ENDPOINT_SOCKET}/social/outlook/oauth?mode=login`,
        '_self'
      );
      break;
  }
};

export const socialSignUp = (source: string) => {
  switch (source) {
    case 'Google':
      window.open(
        `${process.env.REACT_APP_API_ENDPOINT_SOCKET}/social/google/oauth?mode=register`,
        '_self'
      );
      break;
    case 'Outlook':
      window.open(
        `${process.env.REACT_APP_API_ENDPOINT_SOCKET}/social/outlook/oauth?mode=register`,
        '_self'
      );
      break;
  }
};

export const openMail = (mail: string) => {
  if (mail === 'Gmail') {
    window.open('https://mail.google.com/mail/', '_blank');
  } else if (mail === 'Outlook') {
    window.open('https://outlook.live.com/mail/', '_blank');
  }
};
